export const THEME_KEY = 'layout-mode';
